import { EmbeddedObjectShort } from '@pages/FormCreateOrEdit/types'

import { EmbeddedObject } from '@gantt/components/GanttCreateOrEdit'

export const getPathString = (paths: EmbeddedObject[] | EmbeddedObjectShort[], prefix = '') => {
  return paths.map(obj => `${prefix}${obj.field}`).join('.')
}
